var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlueLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 2",
    viewBox: "0 0 984.3 263.47",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1 {\n        fill: #0068ff;\n        stroke-width: 0px;\n      }"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M53.31,8.8h105.95v47.16H50.06v56.23h109.19v47.16H50.06v99.76H0V62.11C0,32.67,23.87,8.8,53.31,8.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m177.11 29.38c0-16.69 13.06-29.38 29.75-29.38s29.75 12.7 29.75 29.38-13.06 29.38-29.75 29.38-29.75-12.7-29.75-29.38z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 183.27,
    y: 74.1,
    width: 47.16,
    height: 185.01
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m248.65 166.61c0-55.14 38.82-96.86 90.33-96.86 24.67 0 45.35 9.8 60.22 26.12v-87.07h47.16v189.01c0 9.8 5.44 15.6 15.6 15.6h3.63v45.71h-13.42c-25.39 0-41.72-9.07-48.97-26.85-14.87 19.23-37.37 31.2-64.21 31.2-51.51 0-90.33-41.72-90.33-96.86zm150.55 0c0-29.02-21.77-51.15-51.15-51.15s-50.79 22.13-50.79 51.15 21.77 51.15 50.79 51.15 51.15-22.13 51.15-51.15z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m472.39 166.61c0-55.14 42.81-96.86 99.4-96.86s99.4 41.72 99.4 97.22c0 4.72-0.36 11.61-1.45 15.96h-146.92c6.17 23.94 25.03 39.54 50.43 39.54 19.23 0 35.91-8.71 43.9-20.68h51.15c-14.15 36.64-50.79 61.67-95.77 61.67-57.32 0-100.13-41.72-100.13-96.86zm50.79-18.14h97.22c-5.8-22.49-24.67-37.73-48.61-37.73s-42.08 14.88-48.61 37.73z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m747.98 29.38c0-16.69 13.06-29.38 29.75-29.38s29.75 12.7 29.75 29.38-13.06 29.38-29.75 29.38-29.75-12.7-29.75-29.38z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 754.15,
    y: 74.1,
    width: 47.16,
    height: 185.01
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 687.96,
    y: 8.8,
    width: 47.16,
    height: 250.31
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m820.33 207.96 91.78-88.52h-90.33v-45.35h155.99v45.35l-93.96 90.33c11.25 5.08 24.31 7.98 37.73 7.98 23.94 0 47.52-8.71 62.76-23.58v50.06c-16.33 12.33-41.36 19.23-66.39 19.23s-49.7-7.25-67.48-21.04l-20.31 19.59h-9.8v-54.05z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueLogo);
export default __webpack_public_path__ + "static/media/blue-logo.bf4d90ee46a6b67cfd8c25e02f2997b1.svg";
export { ForwardRef as ReactComponent };